import { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Progress, Typography } from 'antd';

import { StyledLoading } from './styled';

const { Title } = Typography;

interface IProps {
  type?: 'screen' | 'static' | 'overlay';
  percent?: number;
  blurred?: boolean;
}

const Loading: FC<IProps> = ({ type, percent, blurred }) => {
  const { t } = useTranslation();

  return (
    <StyledLoading type={type} $blurred={blurred}>
      {percent ? (
        <>
          <Progress
            percent={percent}
            type="circle"
            strokeColor={{ '0%': '#108ee9', '100%': '#87d068' }}
            style={{ color: '#ffffff' }}
          />
          <Title level={5} className="loading-title">
            {t('messages.please_not_close')}
          </Title>
        </>
      ) : (
        <>
          <LoadingOutlined style={{ fontSize: 50 }} />
          <Title level={2}>{t('common.loading')}</Title>
        </>
      )}
    </StyledLoading>
  );
};

export default Loading;
